import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { BusinessRulesInterface } from '../../../../interfaces/business-rules.interface';
import { BusinessRulesService } from '../../../../services/business-rules.service';
import { BusinessRulesTypeEnum } from '../../../../enums/businessRulesTypes.enum';
import { BusinessRulesHelper } from '../../business-rules-helper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-business-rules-block-type',
  templateUrl: './business-rules-blockType.component.html',
  styleUrls: ['./business-rules-blockType.component.scss']
})
export class BusinessRulesBlockTypeComponent implements OnInit, OnChanges {
  @Input()
  businessRule: BusinessRulesInterface;
  @Input()
  type: BusinessRulesTypeEnum;
  @Output()
  isActivated = new EventEmitter<string>();
  public isActive = false;
  public ruleText = BusinessRulesHelper;
  isSubmitting = false;

  constructor(
    private toastr: ToastsManager,
    private businessRuleService: BusinessRulesService,
    public translate: TranslateService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    const update = changes['businessRule'];
    if (update && update.currentValue) {
      this.isActive = update.currentValue.isActive;
    }
  }

  saveRule(): void {
    if (!this.businessRule) {
      const rule: BusinessRulesInterface = {
        type: this.type,
        isActive: this.isActive
      };

      this.isSubmitting = true;

      this.businessRuleService.create(rule).subscribe(createdRule => {
        this.businessRule = createdRule;
        this.isSubmitting = false;
      });
      return;
    }

    const businessRuleToBeUpdated = {
      ...this.businessRule,
      isActive: this.isActive
    };
    this.isSubmitting = true;

    this.businessRuleService.update(businessRuleToBeUpdated, this.businessRule._id).subscribe(
      businessRule => {
        this.businessRule = businessRule;
        this.isActivated.emit();
        this.isSubmitting = true;
        return this.toastr.success(this.translate.instant('BUSINESS_RULES_BLOCK_TYPE.COMPONENT.SUCCESS'));
      },
      () => {
        this.isSubmitting = true;
        this.toastr.error(this.translate.instant('BUSINESS_RULES_BLOCK_TYPE.COMPONENT.ERROR'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules-components/business-rules-blockType/business-rules-blockType.component.ts